import register from '../../../../global/js/registry';
export default register('m-search-field', () => import(/* webpackMode: "lazy" */ './m-search-field.controller'));
